export default {
	name: null,
	service: null,
	shared: false,
	introducer: null,
	private: false,
	service_providers: [],
	create_leads: true,
	create_managed_cases: true,
	single_quote: false,
	// commission_type: null,
	// calm_commission_price: null,
	// calm_commission_percent: null,
	// introducer_commission_percent: null,
	fees: {
		conveyancing: {
			sale: {
				fee_transaction_bands: [{
					upto: null,
					fee: null,
				}],
				fee_telegraphic_transfer: null,
				fee_leasehold_property: null,
				fee_islamic_mortgage: null,
				fee_new_build: null,
				fee_shared_ownership: null,
				fee_right_to_buy: null,
				fee_transfer_of_equity: null,
				fee_auction_repossession: null,
				fee_help_to_buy_scheme: null,
				fee_help_to_buy_isa: null,
				fee_stamp_duty_form: null,
				fee_mortgage_admin: null,
				fee_lawyer_checker: null,
				fee_buy_to_let: null,
				fee_file_admin: null,
				fee_lender_monitor: null,
				disbursement_search_pack: null,
				disbursement_bankruptcy_search: null,
				disbursement_office_copies_title_plan: null,
				disbursement_land_registry_pre_completion: null,
				disbursement_remortgage_search_policy: null,
				// remove
				disbursement_id_check: null,
			},
			purchase: {
				fee_transaction_bands: [{
					upto: null,
					fee: null,
				}],
				fee_telegraphic_transfer: null,
				fee_leasehold_property: null,
				fee_islamic_mortgage: null,
				fee_new_build: null,
				fee_shared_ownership: null,
				fee_right_to_buy: null,
				fee_transfer_of_equity: null,
				fee_auction_repossession: null,
				fee_help_to_buy_scheme: null,
				fee_help_to_buy_isa: null,
				fee_stamp_duty_form: null,
				fee_mortgage_admin: null,
				fee_lawyer_checker: null,
				fee_buy_to_let: null,
				disbursement_search_pack: null,
				disbursement_bankruptcy_search: null,
				disbursement_office_copies_title_plan: null,
				disbursement_land_registry_pre_completion: null,
				disbursement_remortgage_search_policy: null,
				// remove
				disbursement_id_check: null,
			},
			remortgage: {
				fee_transaction_bands: [{
					upto: null,
					fee: null,
				}],
				fee_telegraphic_transfer: null,
				fee_leasehold_property: null,
				fee_islamic_mortgage: null,
				fee_new_build: null,
				fee_shared_ownership: null,
				fee_right_to_buy: null,
				fee_transfer_of_equity: null,
				fee_auction_repossession: null,
				fee_help_to_buy_scheme: null,
				fee_help_to_buy_isa: null,
				fee_stamp_duty_form: null,
				fee_mortgage_admin: null,
				fee_lawyer_checker: null,
				fee_buy_to_let: null,
				disbursement_search_pack: null,
				disbursement_bankruptcy_search: null,
				disbursement_office_copies_title_plan: null,
				disbursement_land_registry_pre_completion: null,
				disbursement_remortgage_search_policy: null,
				// remove
				disbursement_id_check: null,
			},
			other: {
				fee_transaction_bands: [{
					upto: null,
					fee: null,
				}],
				disbursement_id_check: null,
			},
		},
	},
	apply_panel: false,
};
